import { IIcon, ISymbol } from '../interfaces';
import { TABLER_ICON_HEIGHT, TABLER_ICON_WIDTH } from './icons-provider';
import uniqueId from 'lodash-es/uniqueId'

export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

export const createSVG = () : SVGSVGElement => {
    const $svg = document.createElementNS(SVG_NAMESPACE, 'svg');
    $svg.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', 'http://www.w3.org/2000/svg');
    return $svg;
};

export const drawPath = (x:number, y:number, d: string, fill?: string) => {
    const $path = document.createElementNS(SVG_NAMESPACE, 'path');

    $path.setAttribute('d', d);
    $path.setAttribute('x', x.toString());
    $path.setAttribute('y', y.toString());

    if(fill) {
        $path.setAttribute('fill', fill);
    }

    return $path;
};

/**
 * draw a rectangle
 */
export const drawRect = (
    x: number, y: number, width: string, height: string, bgColor?: string,
    strokeColor?: string, strokeWidth?: number, rx?: number, ry?: number, className?: string,
) => {

    const $rect = document.createElementNS(SVG_NAMESPACE, 'rect');

    $rect.setAttribute('x', x.toString());
    $rect.setAttribute('y', y.toString());

    $rect.setAttribute('width', width);
    $rect.setAttribute('height', height);

    if(strokeWidth){
        $rect.setAttribute('stroke-width', strokeWidth.toFixed(2));
    }
    else{
        $rect.setAttribute('stroke', 'none')
        $rect.setAttribute('stroke-width', '0');
    }

    if(strokeColor){
        $rect.setAttribute('stroke', strokeColor);
    }

    if(bgColor) {
        $rect.setAttribute('fill', bgColor);
    }

    if(rx){
        $rect.setAttribute('rx', rx.toString());
    }

    if(ry){
        $rect.setAttribute('ry', ry.toString());
    }

    if(className){
        $rect.setAttribute('class', className);
    }

    return $rect;
};

/**
 * init SVG in browser environment ---> return DOM svg element
 */
export const parseSVG = (svg: string): SVGSVGElement => {
    const $box = document.createElement('div');
    $box.innerHTML = svg;
    return $box.firstElementChild as SVGSVGElement;
};

/**
 * transformation on symbols don't work in Safari!!!
 */
export const svgIconsToSymbols = (icons: IIcon[]) => {
    const symbols: ISymbol[] = [];

    for(let i=0; i<icons.length; i++){
        const icon = icons[i];
        const $svg = parseSVG(icon.svg);

        // remove table description as it looks as a name group in sketch
        const $desc = $svg.querySelector('desc');
        if($desc){
            $desc.remove();
        }

        const id = uniqueId('art-');

        const $symbol = document.createElementNS(SVG_NAMESPACE, 'symbol');
        $symbol.innerHTML = $svg.innerHTML;

        $symbol.setAttribute('id', id);
        $symbol.setAttribute('width', TABLER_ICON_WIDTH.toString());
        $symbol.setAttribute('height', TABLER_ICON_HEIGHT.toString());
        $symbol.setAttribute('viewBox', `0 0 ${ TABLER_ICON_WIDTH } ${ TABLER_ICON_HEIGHT }`);

        symbols.push({
            $symbol,
            id,
        });
    }

    return symbols;
};
